import { TransactionType } from "enums";

export const transactionTypeOptions = [
  { label: "Sale", value: TransactionType.Sale },
  { label: "Refund", value: TransactionType.Refund },
  { label: "Void", value: TransactionType.Void },
  { label: "Non-Sale", value: TransactionType.NonSale },
  { label: "Manual Adjustment", value: TransactionType.ManualAdjustment },
  { label: "Return", value: TransactionType.Return },
];

export const initialFilterState = () => {
  return {
    dateType: "transactionDate",
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "salesInvoiceNo",
    statuses: transactionTypeOptions.map((o) => o.value),
    order: "desc",
    page: 1,
    perPage: 10,
  };
};
